import React from "react";

const STEPS = [
  {
    number: "1",
    title: "Tell Us What You Need",
    text: "Share your goals, experience and when you can practice — in your timezone.",
  },
  {
    number: "2",
    title: "Find Your Teacher",
    text: "Browse teachers and see live class times already converted to your timezone.",
  },
  {
    number: "3",
    title: "Have a Free Consultation",
    text: "Ask questions and understand the teaching approach.",
  },
  {
    number: "4",
    title: "Start Your Yoga Practice",
    text: "Book your preferred sessions or course.",
  },
];

export default function HowItWorksSection() {
  return (
    <section className="bg-white" aria-labelledby="how-it-works-heading">
      <div className="container mx-auto px-4 py-16 md:py-20">
        <div className="mx-auto max-w-3xl text-center">
          <h2
            id="how-it-works-heading"
            className="text-3xl font-black tracking-tight text-gray-900 md:text-4xl"
          >
            How It Works
          </h2>
          <p className="mt-3 text-gray-600">
            From your first enquiry to your first session — a clear path to the right teacher.
          </p>
        </div>

        <ol className="mx-auto mt-12 grid max-w-5xl gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step) => (
            <li key={step.number} className="relative text-center sm:text-left">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-emerald-600 text-sm font-bold text-white">
                {step.number}
              </span>
              <h3 className="mt-4 text-base font-bold text-gray-900">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-600">{step.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
